import { STRIPE_KEY } from "../constants.js";

export default ({ email, redirectUrl, createIntentUrl, currency, amount, body = {} }) => ({
  elements: null,
  stripe: null,
  loading: false,
  errorMessage: null,
  amount,
  body,

  async init() {
    this.loading = true;
    this.stripe = Stripe(STRIPE_KEY);

    this.elements = this.stripe.elements({
      mode: "payment",
      currency: currency,
      amount: this.amount,
      appearance: {
        theme: "stripe",
        variables: {
          colorPrimary: "#1e95a6",
        },
      },
    });

    const paymentElement = this.elements.create("payment", {
      layout: "tabs",
      defaultValues: {
        billingDetails: {
          email: email,
        },
      },
    });

    paymentElement.mount(this.$refs.payment);
    this.loading = false;
  },

  async onSubmit() {
    this.loading = true;
    this.errorMessage = null;

    const { error: submitError } = await this.elements.submit();

    if (submitError) {
      this.errorMessage = submitError.message;
      this.loading = false;

      return;
    }

    let clientSecret;
    try {
      const response = await fetch(createIntentUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify(this.body),
      });

      if (!response.ok) {
        throw new Error();
      }
      ({ clientSecret } = await response.json());
    } catch {
      this.errorMessage = "Could not initialize payment. Please try again.";
      this.loading = false;
      return;
    }

    const { error } = await this.stripe.confirmPayment({
      clientSecret: clientSecret,
      elements: this.elements,
      confirmParams: {
        return_url: redirectUrl,
      },
    });

    if (error) {
      this.errorMessage =
        error.type === "card_error" || error.type === "validation_error"
          ? error.message
          : "An unexpected error occurred.";
      this.loading = false;
    }
  },
});
